import React from "react";
import { Col, Space } from "antd";

import RentManualList from "../../components/RentManualList";
import CatalogList from "../../components/CatalogList";
import RentVedioManualList from "../../components/RentVedioManualList";

function ManualManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">매뉴얼 관리</h3>
                <RentManualList />
                <RentVedioManualList />
            </Space>
        </div>
    );
}

export default ManualManagement;
